export const environment = {
  production: false,
  dev: true,

  baseUrl: 'https://apex.renewbuyinsurance.in/',
  amsurl: 'https://accounts.rbstaging.in/',

  artivatic_flag: false,
  apex: 'https://dev-apex.rbstaging.in/',
  // apexD2C: 'https://d2c.renewbuyinsurance.in/',
  apex_local: 'http://test.rbstaging.in/',

  profile_redirection: 'https://partners.rbstaging.in/home',
  backend_url: 'https://apex.renewbuyinsurance.in',
  partner_v2: 'https://partners.rbstaging.in/v2/',
  token:
    'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpZCI6IlJCMDAwMTQ1NzciLCJleHAiOjE3NzA4MDEwMzZ9.m8P-ht00bpMeCJMlWXIYte0pz6rHT0S2onu5TaFBWI8',
  key_1: '7b574be9-96c2-4afc-934e-a333f9d27e94',
  key_2: 'YiBYbVTAOIT6TD2k8L3S22pou4IVBdR6',
  partnerswithoutPOS: [
    'EI00347646',
    'EI00237385',
    'EI00118757',
    'EI00070005',
    'EI00073533',
    'EI00065401',
    'EI00083965',
    'EI00050220',
    'EI00069422',
    'EI00033473',
    'EI00020047',
    'EI00033180',
    'EI00049055',
    'EI00051524',
    'EI00065401',
    'EI00083965',
    'EI00050220',
    'EI00069422',
    'EI00020047',
    'EI00033180',
    'EI00049055',
    'EI00090180',
    'EI00070005',
    'EI00000002',
    'EI00016174',
    'EI00000435',
    'EI00064920',
    'EI00020297',
    'EI00114477',
    'EI00233510',
    'EI00236494',
    'EI00240908',
    'EI00247598',
    'EI00245544',
    'EI00250394',
    'EI00248861',
    'EI00250782',
    'EI00251262',
    'EI00251038',
    'EI00249510',
    'EI00252434',
    'EI00261566',
    'EI00261721',
    'EI00273287',
    'EI00273620',
    'EI00266175',
    'EI00330135',
    'EI00151631',
  ],
  instantQuotesApiKey: 'HTdtmtVjco0z3wIEhj1MsFPjOMRYKD0v',
  instantQuotesAppId: '5a52b07f-d8ad-4b12-ba80-def5fcf16d8c',
  whatsappLink: 'https://wa.me/9810972473',
};
